<template>
  <div>
    <!-- <div id="shopify-product-reviews" v-if="this.reviewSource === 'shopify'" :data-id="product.id"></div>
    <div class="yotpo yotpo-main-widget" v-else :data-product-id="product.id" :data-price="product.price" :data-currency="this.currency" :data-name="product.title" :data-url="product.handle" :data-image-url="product.featured_image"></div> -->
  </div>
</template>

<script>
export default {
  name: 'ProductReviews',
  props: {
    product: Object,
    customFields: Object
  },
  data () {
    return {
      reviewSource: window.bvaccel && window.bvaccel.reviewSource,
      currency: window.bvaccel && window.bvaccel.currency
    }
  },
  mounted () {

  }
}
</script>

<style lang="scss">
// see styles/product-reviews.scss
</style>
